export const LOAD_LOCATIONS_SUCCESS = 'LOAD_LOCATIONS_SUCCESS'
export const LOAD_LOCATION_MAPPING_STARTED = 'LOAD_LOCATION_MAPPING_STARTED'
export const LOAD_LOCATION_MAPPING_SUCCESS = 'LOAD_LOCATION_MAPPING_SUCCESS'
export const ADD_LOCATION_MAPPING_SUCCESS = 'ADD_LOCATION_MAPPING_SUCCESS'
export const UPDATE_LOCATION_MAPPING_SUCCESS = 'UPDATE_LOCATION_MAPPING_SUCCESS'
export const REMOVE_LOCATION_MAPPING_OPTIMISTIC = 'REMOVE_LOCATION_MAPPING_OPTIMISTIC'
